export const planUpdateSuccess = {
  title: 'Plan Change Request',
  message:
    'Plan change request acknowledged. Please check the email address of the registered account holder to confirm the change of plan. Any issues please contact ',
};

export const requireApprovalMessage = {
  title: 'Plan Change Request',
  message: 'Changing to this plan requires approval. Do you want to proceed?',
};

export const PRODUCT_LINE = {
  suite: 'Suite',
};

export const AVAILABLE_RESOURCES = {
  // sites: { label: 'Sites', apiKey: 'numSites', detailApiKey: 'sites' },
  // supervisors: {
  //   label: 'Supervisors',
  //   overviewLabel: 'Managers & Supervisors',
  //   apiKey: 'numSupervisors',
  //   detailApiKey: ['managers', 'supervisors'],
  // },
  // responder: {
  //   label: 'Responders',
  //   apiKey: 'numResponders',
  //   detailApiKey: 'responders',
  // },
  // guard: { label: 'Guards', apiKey: 'numGuards', detailApiKey: 'guards' },
  // cleaner: {
  //   label: 'Cleaners',
  //   apiKey: 'numCleaners',
  //   detailApiKey: 'cleaners',
  // },
  // driver: { label: 'Drivers', apiKey: 'numDrivers', detailApiKey: 'drivers' },
  roles: {
    label: 'Roles',
    apiKey: 'roles',
  },
  features: {
    label: 'Features',
    apiKey: 'features',
  },
  noOfProducts: {
    label: 'No. of products',
    apiKey: products => products.length,
  },
};
